exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".address-1[data-v-697761b8]{color:#000;font-weight:600}.address-2[data-v-697761b8]{color:#444}.address-secondary[data-v-697761b8]{color:#999}h3[data-v-697761b8]{margin:.3rem 0;font-weight:600}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-697761b8","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/staff/blocks/Delivery.vue
// module id = 507
// module chunks = 0